import { render } from "./AppGaratkomunale.vue?vue&type=template&id=e5892c3c"
const script = {}

import "./AppGaratkomunale.vue?vue&type=style&index=0&id=e5892c3c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__